import { HealthTechnologyType, UserRole } from './core/model/user.model';

import { AuthGuard } from './core/guards/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  {
    path: 'verificacao-autenticidade',
    loadComponent: () =>
      import('./pages/verificacao-autenticidade/verificacao-autenticidade.component').then(
        (c) => c.VerificacaoAutenticidadeComponent,
      ),
  },
  {
    path: 'notas-tecnicas',
    loadComponent: () =>
      import('./pages/nota-tecnica/nota-tecnica.component').then(
        (c) => c.NotaTecnicaComponent,
      ),
  },
  {
    path: 'area-restrita-login',
    loadComponent: () =>
      import('./pages/area-restrita/area-restrita-login/area-restrita-login.component').then(
        (c) => c.AreaRestritaLoginComponent,
      ),
  },
  {
    path: 'recuperar-senha',
    loadComponent: () =>
      import('./pages/area-restrita/area-restrita-recuperar-senha/area-restrita-recuperar-senha.component').then(
        (c) => c.AreaRestritaRecuperarSenhaComponent,
      ),
  },
  {
    path: 'recuperar-senha/enviado',
    loadComponent: () =>
      import('./pages/area-restrita/area-restrita-recuperar-senha-enviado/area-restrita-recuperar-senha-enviado.component').then(
        (c) => c.AreaRestritaRecuperarSenhaEnviadoComponent,
      ),
  },
  {
    path: 'recuperar-senha/redefinir',
    loadComponent: () =>
      import('./pages/area-restrita/area-restrita-redefinir-senha/area-restrita-redefinir-senha.component').then(
        (c) => c.AreaRestritaRedefinirSenhaComponent,
      ),
  },
  {
    path: 'area-restrita/administrativo',
    loadComponent: () =>
      import('./pages/area-restrita/area-restrita-gerenciamento/area-restrita-gerenciamento.component').then(
        (c) => c.AreaRestritaGerenciamentoComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      // COSMÉTICOS
      {
        path: 'cosmeticos-genericos',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/cosmetico-generico/cosmetico-generico.component').then(
            (c) => c.ListarCosmeticoGenericoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },
      {
        path: 'cosmeticos-genericos/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/cosmetico-generico/visualizar-cosmetico-generico/visualizar-cosmetico-generico.component').then(
            (c) => c.VisualizarCosmeticoGenericoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },
      {
        path: 'cosmeticos/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/cosmetico/cosmetico-detalhes/cosmetico-detalhes.component').then(
            (c) => c.CosmeticoDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },
      {
        path: 'cosmeticos-comerciais',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/cosmetico-comercial/cosmetico-comercial.component').then(
            (c) => c.CosmeticoComercialListComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },
      {
        path: 'cosmeticos-comerciais/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/cosmetico-comercial/cosmetico-comercial-detalhes/cosmetico-comercial-detalhes.component').then(
            (c) => c.CosmeticoComercialDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },

      // INSUMOS
      {
        path: 'insumos',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumo/insumo.component').then(
            (c) => c.ListarInsumosComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'insumos/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumo/detalhes-insumo/detalhes-insumo.component').then(
            (c) => c.DetalhesInsumoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'insumos-comerciais',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumos/insumo-comercial/insumo-comercial.component').then(
            (c) => c.InsumoComercialListComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'insumos-comerciais/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumos/insumo-comercial/detalhar-insumo-comercial/insumo-comercial-detalhes.component').then(
            (c) => c.InsumoComercialDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },

      // PRODUTOS NUTRICIONAIS
      {
        path: 'produtos-nutricionais',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/produto-nutricional/produto-nutricional.component').then(
            (c) => c.ListarProdutoNutricionalComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },
      {
        path: 'produtos-nutricionais/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/produto-nutricional/produto-nutricional-detalhes/produto-nutricional-detalhes.component').then(
            (c) => c.ProdutoNutricionalDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },

      // PRODUTOS NUTRICIONAIS COMERCIAIS
      {
        path: 'produtos-nutricionais-comerciais',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/commercial-nutritional-products/produto-nutricional-comercial.component').then(
            (c) => c.ProdutoNutritionalComercialListComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },
      {
        path: 'produtos-nutricionais-comerciais/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/commercial-nutritional-products/detalhar-produto-comercial/produto-comercial-detalhes.component').then(
            (c) => c.ProdutoComercialDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },
      {
        path: 'produtos-nutricionais-genericos',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/produto-nutricional-generico/produto-nutricional-generico.component').then(
            (c) => c.ListarProdutoNutricionalGenericoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },
      {
        path: 'produtos-nutricionais-genericos/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/produto-nutricional-generico/visualizar-produto-nutricional-generico/visualizar-produto-nutricional-generico.component').then(
            (c) => c.VisualizarProdutoNutricionalGenericoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },

      {
        path: 'insumo-generico',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumos/insumo-generico/insumo-generico.component').then(
            (c) => c.ListarInsumoGenericoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'insumo-generico/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumos/insumo-generico/visualizar-insumo-generico/visualizar-insumo-generico.component').then(
            (c) => c.VisualizarInsumoGenericoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },

      {
        path: 'insumos-comerciais',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumos/insumo-comercial/insumo-comercial.component').then(
            (c) => c.InsumoComercialListComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'insumos-comerciais/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/insumos/insumo-comercial/detalhar-insumo-comercial/insumo-comercial-detalhes.component').then(
            (c) => c.InsumoComercialDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },

      // MEDICAMENTOS
      {
        path: 'medicamentos',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/medicamento.component').then(
            (c) => c.MedicamentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/cadastrar-medicamento',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/cadastrar-medicamento/cadastrar-medicamento.component').then(
            (c) => c.CadastrarMedicamentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/editar-medicamento/:id',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/cadastrar-medicamento/cadastrar-medicamento.component').then(
            (c) => c.CadastrarMedicamentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/importacoes-anvisa',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/importacoes-anvisa/importacoes-anvisa.component').then(
            (c) => c.ImportacoesAnvisaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/importacoes-anvisa/:importId',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/revisao-importacao-anvisa/revisao-importacao-anvisa.component').then(
            (c) => c.RevisaoImportacaoAnvisaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/:id',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/medicamento-id/medicamento-id.component').then(
            (c) => c.MedicamentoIdComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/:id/apresentacao/cadastrar',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/cadastrar-apresentacao/cadastrar-apresentacao.component').then(
            (c) => c.CadastrarApresentacaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'medicamentos/:id/apresentacao/editar',
        loadComponent: () =>
          import('./pages/area-restrita/medicamento/editar-apresentacao/editar-apresentacao.component').then(
            (c) => c.EditarApresentacaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },

      // PROCEDIMENTOS
      {
        path: 'procedimentos',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/procedure/procedure.component').then(
            (c) => c.ProcedureComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.PROCEDURE],
        },
      },
      {
        path: 'procedimentos/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/procedure/procedure-detalhes/procedure-detalhes.component').then(
            (c) => c.ProcedureDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.PROCEDURE],
        },
      },

      ///////////////////
      {
        path: 'listar-notas-tecnicas-individualizadas',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica-individualizada/nota-tecnica-individualizada.component').then(
            (c) => c.NotaTecnicaIndividualizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'cadastrar-nota-tecnica-individualizada',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica-individualizada/cadastrar-nota-tecnica-individualizada/cadastrar-nota-tecnica-individualizada.component').then(
            (c) => c.CadastrarNotaTecnicaIndividualizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'detalhar-nota-tecnica-individualizada/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica-individualizada/detalhar-nota-tecnica-individualizada/detalhar-nota-tecnica-individualizada.component').then(
            (c) => c.DetalharNotaTecnicaIndividualizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'editar-nota-tecnica-individualizada/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica-individualizada/editar-nota-tecnica-individualizada/editar-nota-tecnica-individualizada.component').then(
            (c) => c.EditarNotaTecnicaIndividualizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'listar-notas-tecnicas-padronizadas',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-padronizada/listar-nota-tecnica-padronizada/listar-nota-tecnica-padronizada.component').then(
            (c) => c.ListarNotaTecnicaPadronizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-nota-tecnica-padronizada',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-padronizada/cadastrar-nota-tecnica-padronizada/cadastrar-nota-tecnica-padronizada.component').then(
            (c) => c.CadastrarNotaTecnicaPadronizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-nota-tecnica-padronizada/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-padronizada/editar-nota-tecnica-padronizada/editar-nota-tecnica-padronizada.component').then(
            (c) => c.EditarNotaTecnicaPadronizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'nota-tecnica-padronizada/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-padronizada/detalhar-nota-tecnica-padronizada/detalhar-nota-tecnica-padronizada.component').then(
            (c) => c.DetalharNotaTecnicaPadronizadaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-notas-tecnicas-procedimento',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-procedimento/procedimento/listar-nota-tecnica-procedimento.component').then(
            (c) => c.ListarNotaTecnicaProcedimentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.PROCEDURE],
        },
      },
      {
        path: 'procedimento/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-procedimento/procedimento/procedimento-id/procedimento-id.component').then(
            (c) => c.ProcedimentoIdComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.PROCEDURE],
        },
      },
      {
        path: 'listar-notas-tecnicas-todas',
        loadComponent: () =>
          import('./pages/area-restrita/listar-nota-tecnica/listar-nota-tecnica.component').then(
            (c) => c.ListarNotaTecnicaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'listar-notas-tecnicas-cosmetico',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-cosmetico/listar-nota-tecnica-cosmetico/listar-nota-tecnica-cosmetico.component').then(
            (c) => c.ListarNotaTecnicaCosmeticoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },
      {
        path: 'nota-tecnica-cosmetico/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-cosmetico/detalhar-nota-tecnica-cosmetico/detalhar-nota-tecnica-cosmetico.component').then(
            (c) => c.DetalharNotaTecnicaCosmeticoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.COSMETIC],
        },
      },
      {
        path: 'listar-notas-tecnicas-insumos',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-insumo/listar-nota-tecnica-insumo/listar-nota-tecnica-insumo.component').then(
            (c) => c.ListarNotaTecnicaInsumoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'nota-tecnica-insumo/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-insumo/detalhar-nota-tecnica-insumo/detalhar-nota-tecnica-insumo.component').then(
            (c) => c.DetalharNotaTecnicaInsumoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.OTHER],
        },
      },
      {
        path: 'listar-notas-tecnicas-produtos-nutricionais',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-produto-nutricional/listar-nota-tecnica-produto-nutricional/listar-nota-tecnica-produto-nutricional.component').then(
            (c) => c.ListarNotaTecnicaProdutoNutricionalComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },
      {
        path: 'nota-tecnica-produto-nutricional/:id',
        loadComponent: () =>
          import('./pages/area-restrita/nota-tecnica/nota-tecnica-produto-nutricional/detalhar-nota-tecnica-produto-nutricional/detalhar-nota-tecnica-produto-nutricional.component').then(
            (c) => c.DetalharNotaTecnicaProdutoNutricionalComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.NUTRITIONAL_PRODUCT],
        },
      },
      {
        path: 'listar-forma-administracao',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-administracao/listar-forma-administracao/listar-forma-administracao.component').then(
            (c) => c.ListarFormaAdministracaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
          ],
        },
      },
      {
        path: 'cadastrar-forma-administracao',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-administracao/cadastrar-forma-administracao/cadastrar-forma-administracao.component').then(
            (c) => c.CadastrarFormaAdministracaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
          ],
        },
      },
      {
        path: 'editar-forma-administracao',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-administracao/cadastrar-forma-administracao/cadastrar-forma-administracao.component').then(
            (c) => c.CadastrarFormaAdministracaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
          ],
        },
      },
      {
        path: 'listar-laboratorio',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/laboratorio/listar-laboratorios/listar-laboratorios.component').then(
            (c) => c.ListarLaboratoriosComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-laboratorio',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/laboratorio/cadastrar-laboratorio/cadastrar-laboratorio.component').then(
            (c) => c.CadastrarLaboratorioComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-laboratorio',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/laboratorio/cadastrar-laboratorio/cadastrar-laboratorio.component').then(
            (c) => c.CadastrarLaboratorioComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-principio-ativo',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/listar-principio-ativo/listar-principio-ativo.component').then(
            (c) => c.ListarPrincipioAtivoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-principio-ativo',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/cadastrar-principio-ativo/cadastrar-principio-ativo.component').then(
            (c) => c.CadastrarPrincipioAtivoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-principio-ativo/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/cadastrar-principio-ativo/cadastrar-principio-ativo.component').then(
            (c) => c.CadastrarPrincipioAtivoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'principio-ativo/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/principio-ativo-id/principio-ativo-id.component').then(
            (c) => c.PrincipioAtivoIdComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-dosagem/:principioAtivoId',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/principio-ativo-id/principio-ativo-dosagens/cadastrar-dosagem/cadastrar-dosagem.component').then(
            (c) => c.CadastrarDosagemComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-dosagem/:principioAtivoId/:dosageId',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/principio-ativo-id/principio-ativo-dosagens/cadastrar-dosagem/cadastrar-dosagem.component').then(
            (c) => c.CadastrarDosagemComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'detalhar-dosagem/:principioAtivoId/:dosageId',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/principio-ativo/principio-ativo-id/principio-ativo-dosagens/cadastrar-dosagem/cadastrar-dosagem.component').then(
            (c) => c.CadastrarDosagemComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-condicoes-clinicas',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/condicoes-clinicas/listar-condicoes-clinicas/listar-condicoes-clinicas.component').then(
            (c) => c.ListarCondicoesClinicasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-condicoes-clinicas',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/condicoes-clinicas/cadastrar-condicoes-clinicas/cadastrar-condicoes-clinicas.component').then(
            (c) => c.CadastrarCondicoesClinicasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-condicoes-clinicas',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/condicoes-clinicas/cadastrar-condicoes-clinicas/cadastrar-condicoes-clinicas.component').then(
            (c) => c.CadastrarCondicoesClinicasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-tipo-receituario',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/tipo-receituario/listar-tipo-receituario/listar-tipo-receituario.component').then(
            (c) => c.ListarTipoReceituarioComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
          ],
        },
      },
      {
        path: 'listar-classe-terapeutica',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/classe-terapeutica/listar-classe-terapeutica/listar-classe-terapeutica.component').then(
            (c) => c.ListarClasseTerapeuticaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-classe-terapeutica',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/classe-terapeutica/cadastrar-classe-terapeutica/cadastrar-classe-terapeutica.component').then(
            (c) => c.CadastrarClasseTerapeuticaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-classe-terapeutica',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/classe-terapeutica/cadastrar-classe-terapeutica/cadastrar-classe-terapeutica.component').then(
            (c) => c.CadastrarClasseTerapeuticaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-ambiente-administracao',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/ambiente-administracao/listar-ambiente-administracao/listar-ambiente-administracao.component').then(
            (c) => c.ListarAmbienteAdministracaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-ambiente-administracao',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/ambiente-administracao/cadastrar-ambiente-administracao/cadastrar-ambiente-administracao.component').then(
            (c) => c.CadastrarAmbienteAdministracaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-ambiente-administracao/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/ambiente-administracao/cadastrar-ambiente-administracao/cadastrar-ambiente-administracao.component').then(
            (c) => c.CadastrarAmbienteAdministracaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-saude-baseada-em-evidencias',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/saude-baseada-em-evidencias/listar-saude-baseada-em-evidencias/listar-saude-baseada-em-evidencias.component').then(
            (c) => c.ListarSaudeBaseadaEmEvidenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-saude-baseada-em-evidencias',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/saude-baseada-em-evidencias/cadastrar-saude-baseada-em-evidencias/cadastrar-saude-baseada-em-evidencias.component').then(
            (c) => c.CadastrarSaudeBaseadaEmEvidenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'detalhar-saude-baseada-em-evidencias/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/saude-baseada-em-evidencias/cadastrar-saude-baseada-em-evidencias/cadastrar-saude-baseada-em-evidencias.component').then(
            (c) => c.CadastrarSaudeBaseadaEmEvidenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-saude-baseada-em-evidencias/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/saude-baseada-em-evidencias/cadastrar-saude-baseada-em-evidencias/cadastrar-saude-baseada-em-evidencias.component').then(
            (c) => c.CadastrarSaudeBaseadaEmEvidenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-deliberacao-conitec',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/deliberacao-conitec/listar-deliberacao-conitec/listar-deliberacao-conitec.component').then(
            (c) => c.ListarDeliberacaoConitecComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-deliberacao-conitec',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/deliberacao-conitec/cadastrar-deliberacao-conitec/cadastrar-deliberacao-conitec.component').then(
            (c) => c.CadastrarDeliberacaoConitecComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'detalhar-deliberacao-conitec',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/deliberacao-conitec/cadastrar-deliberacao-conitec/cadastrar-deliberacao-conitec.component').then(
            (c) => c.CadastrarDeliberacaoConitecComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-deliberacao-conitec',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/deliberacao-conitec/cadastrar-deliberacao-conitec/cadastrar-deliberacao-conitec.component').then(
            (c) => c.CadastrarDeliberacaoConitecComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-alternativas-sus',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/alternativas-sus/listar-alternativas-sus/listar-alternativas-sus.component').then(
            (c) => c.ListarAlternativasSusComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'cadastrar-alternativas-sus',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/alternativas-sus/cadastrar-alternativas-sus/cadastrar-alternativas-sus.component').then(
            (c) => c.CadastrarAlternativasSusComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'detalhar-alternativas-sus/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/alternativas-sus/cadastrar-alternativas-sus/cadastrar-alternativas-sus.component').then(
            (c) => c.CadastrarAlternativasSusComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'editar-alternativas-sus/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/alternativas-sus/cadastrar-alternativas-sus/cadastrar-alternativas-sus.component').then(
            (c) => c.CadastrarAlternativasSusComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-forma-acesso',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-acesso/listar-forma-acesso/listar-forma-acesso.component').then(
            (c) => c.ListarFormaAcessoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-forma-acesso',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-acesso/cadastrar-forma-acesso/cadastrar-forma-acesso.component').then(
            (c) => c.CadastrarFormaAcessoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-forma-acesso/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-acesso/cadastrar-forma-acesso/cadastrar-forma-acesso.component').then(
            (c) => c.CadastrarFormaAcessoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-forma-farmaceutica',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-farmaceutica/listar-forma-farmaceutica/listar-forma-farmaceutica.component').then(
            (c) => c.ListarFormaFarmaceuticaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [HealthTechnologyType.MEDICATION],
        },
      },
      {
        path: 'listar-pcdt',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/pcdt/listar-pcdt/listar-pcdt.component').then(
            (c) => c.ListarPcdtComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-pcdt',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/pcdt/cadastrar-pcdt/cadastrar-pcdt.component').then(
            (c) => c.CadastrarPcdtComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-pcdt/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/pcdt/editar-pcdt/editar-pcdt.component').then(
            (c) => c.EditarPcdtComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'pcdt/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/pcdt/pcdt-detalhes/pcdt-detalhes.component').then(
            (c) => c.PcdtDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'importacao-cmed',
        loadComponent: () =>
          import('./pages/area-restrita/importacao-cmed/importacao-cmed.component').then(
            (c) => c.ImportacaoCmedComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-procedimentos-sigtap',
        loadComponent: () =>
          import('./pages/area-restrita/integracoes/sigtap/listar-procedimentos-sigtap/listar-procedimentos-sigtap.component').then(
            (c) => c.ListarProcedimentosSigtapComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-usuarios',
        loadComponent: () =>
          import('./pages/area-restrita/usuarios/usuario.component').then(
            (c) => c.ListarUsuariosComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'cadastrar-usuario',
        loadComponent: () =>
          import('./pages/area-restrita/usuarios/cadastrar-usuario/cadastrar-usuario.component').then(
            (c) => c.CadastrarUsuarioComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'editar-usuario/:id',
        loadComponent: () =>
          import('./pages/area-restrita/usuarios/cadastrar-usuario/cadastrar-usuario.component').then(
            (c) => c.CadastrarUsuarioComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'certificado-digital',
        loadComponent: () =>
          import('./pages/area-restrita/certificado-digital/certificado-digital.component').then(
            (c) => c.CertificadoDigitalComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'listar-forma-armazenamento',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-armazenamento/listar-forma-armazenamento/listar-forma-armazenamento.component').then(
            (c) => c.ListarFormaArmazenamentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
          ],
        },
      },
      {
        path: 'cadastrar-forma-armazenamento',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-armazenamento/cadastrar-forma-armazenamento/cadastrar-forma-armazenamento.component').then(
            (c) => c.CadastrarFormaArmazenamentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
          ],
        },
      },
      {
        path: 'editar-forma-armazenamento',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/forma-armazenamento/cadastrar-forma-armazenamento/cadastrar-forma-armazenamento.component').then(
            (c) => c.CadastrarFormaArmazenamentoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
          ],
        },
      },
      {
        path: 'listar-politica-saude',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/politica-saude/listar-politica-saude/listar-politica-saude.component').then(
            (c) => c.ListarPoliticaSaudeComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-politica-saude',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/politica-saude/cadastrar-politica-saude/cadastrar-politica-saude.component').then(
            (c) => c.CadastrarPoliticaSaudeComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-politica-saude/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/politica-saude/cadastrar-politica-saude/cadastrar-politica-saude.component').then(
            (c) => c.CadastrarPoliticaSaudeComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'politica-saude/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/politica-saude/politica-saude-detalhes/politica-saude-detalhes.component').then(
            (c) => c.PoliticaSaudeDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-saiba-mais',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/saiba-mais/listar-saiba-mais/listar-saiba-mais.component').then(
            (c) => c.ListarSaibaMaisFaqComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'cadastrar-saiba-mais',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/saiba-mais/cadastrar-saiba-mais/cadastrar-saiba-mais-modal.component').then(
            (c) => c.CadastrarSaibaMaisFaqModalComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'editar-saiba-mais',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/saiba-mais/cadastrar-saiba-mais/cadastrar-saiba-mais-modal.component').then(
            (c) => c.CadastrarSaibaMaisFaqModalComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'saiba-mais/:id',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/saiba-mais/saiba-mais-detalhes/saiba-mais-detalhes.component').then(
            (c) => c.SaibaMaisFaqDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'listar-links-uteis',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/links-uteis/listar-links-uteis/listar-links-uteis.component').then(
            (c) => c.ListarLinksUteisComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'links-uteis/:id',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/links-uteis/links-uteis-detalhes/links-uteis-detalhes.component').then(
            (c) => c.LinksUteisDetalhesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'listar-links-uteis-categorias',
        loadComponent: () =>
          import('./pages/area-restrita/conteudo/links-uteis-categorias/listar-links-uteis-categorias/listar-links-uteis-categorias.component').then(
            (c) => c.ListarLinksUteisCategoriasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'catmat',
        loadComponent: () =>
          import('./pages/area-restrita/integracoes/catmat/catmat.component').then(
            (c) => c.CatmatComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'siad',
        loadComponent: () =>
          import('./pages/area-restrita/integracoes/siad/siad.component').then(
            (c) => c.SiadComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'tuss',
        loadComponent: () =>
          import('./pages/area-restrita/integracoes/tuss/tuss.component').then(
            (c) => c.TussComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'redes-saude',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/redes-saude/redes-saude.component').then(
            (c) => c.RedesSaudeComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'cadastrar-redes-saude',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/redes-saude/cadastrar-redes-saude/cadastrar-redes-saude.component').then(
            (c) => c.CadastrarRedesSaudeComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'editar-redes-saude/:id',
        loadComponent: () =>
          import('./pages/area-restrita/auxiliares/redes-saude/cadastrar-redes-saude/cadastrar-redes-saude.component').then(
            (c) => c.CadastrarRedesSaudeComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
          techologies: [
            HealthTechnologyType.COSMETIC,
            HealthTechnologyType.MEDICATION,
            HealthTechnologyType.NUTRITIONAL_PRODUCT,
            HealthTechnologyType.OTHER,
            HealthTechnologyType.PROCEDURE,
          ],
        },
      },
      {
        path: 'listar-banners',
        loadComponent: () =>
          import('./pages/area-restrita/banners/listar-banners/listar-banners.component').then(
            (c) => c.ListarBannersComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'em-construcao',
        loadComponent: () =>
          import('./pages/area-restrita/blank/blank.component').then(
            (c) => c.BlankComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.EXTERNAL],
        },
      },
      {
        path: 'entidade-externa',
        loadComponent: () =>
          import('./pages/area-restrita/entidade-externa/entidade-externa.component').then(
            (c) => c.EntidadeExternaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'solicitar-informacoes',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitar-informacoes.component').then(
            (c) => c.SolicitarInformacoesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL],
        },
      },
      {
        path: 'solicitar-nota-tecnica-caso-especifico',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitar-nota-tecnica-caso-especifico/solicitar-nota-tecnica-caso-especifico.component').then(
            (c) => c.SolicitarNotaTecnicaCasoEspecificoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL],
        },
      },
      {
        path: 'solicitar-nota-tecnica-caso-especifico/:id',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitar-nota-tecnica-caso-especifico/solicitar-nota-tecnica-caso-especifico.component').then(
            (c) => c.SolicitarNotaTecnicaCasoEspecificoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL, UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'solicitar-informacoes/nova-nota-tecnica-padrao',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitacao-nova-nota-tecnica-padrao/solicitacao-nova-nota-tecnica-padrao.component').then(
            (c) => c.SolicitacaoNovaNotaTecnicaPadraoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL],
        },
      },
      {
        path: 'solicitar-atualizacao-nota-tecnica',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitacao-atualizacao-nota-tecnica/solicitacao-atualizacao-nota-tecnica.component').then(
            (c) => c.SolicitacaoAtualizacaoNotaTecnicaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL],
        },
      },
      {
        path: 'solicitar-atualizacao-nota-tecnica/:id',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitacao-atualizacao-nota-tecnica/solicitacao-atualizacao-nota-tecnica.component').then(
            (c) => c.SolicitacaoAtualizacaoNotaTecnicaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL, UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'solicitar-informacao-complementar',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitar-informacao-complementar/solicitar-informacao-complementar.component').then(
            (c) => c.SolicitarInformacaoComplementarComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL],
        },
      },
      {
        path: 'detalhar-informacao-complementar/:id',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitar-informacao-complementar/solicitar-informacao-complementar.component').then(
            (c) => c.SolicitarInformacaoComplementarComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL, UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'detalhar-nota-tecnica-padrao/:id',
        loadComponent: () =>
          import('./pages/area-restrita/solicitar-informacoes/solicitacao-nova-nota-tecnica-padrao/solicitacao-nova-nota-tecnica-padrao.component').then(
            (c) => c.SolicitacaoNovaNotaTecnicaPadraoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL, UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'minhas-solicitacoes',
        loadComponent: () =>
          import('./pages/area-restrita/minhas-solicitacoes/minhas-solicitacoes.component').then(
            (c) => c.MinhasSolicitacoesComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL, UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'relatorio-importacoes-anvisa',
        loadComponent: () =>
          import('./pages/area-restrita/relatorio-importacoes-anvisa/relatorio-importacoes-anvisa.component').then(
            (c) => c.RelatorioImportacoesAnvisaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'log-auditoria',
        loadComponent: () =>
          import('./pages/area-restrita/log-auditoria/log-auditoria.component').then(
            (c) => c.LogAuditoriaComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'historico-solicitacao/:id',
        loadComponent: () =>
          import('./pages/area-restrita/minhas-solicitacoes/historico-solicitacao/historico-solicitacao.component').then(
            (c) => c.HistoricoSolicitacaoComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.EXTERNAL, UserRole.ADMIN, UserRole.HEALTH_ANALYST],
        },
      },
      {
        path: 'listar-ausencias',
        loadComponent: () =>
          import('./pages/area-restrita/ausencias/listar-ausencias/listar-ausencias.component').then(
            (c) => c.ListarAusenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'cadastrar-ausencia',
        loadComponent: () =>
          import('./pages/area-restrita/ausencias/cadastrar-ausencias/cadastrar-ausencias.component').then(
            (c) => c.CadastrarAusenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'editar-ausencia/:id',
        loadComponent: () =>
          import('./pages/area-restrita/ausencias/editar-ausencias/editar-ausencias.component').then(
            (c) => c.EditarAusenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
      {
        path: 'detalhar-ausencia/:id',
        loadComponent: () =>
          import('./pages/area-restrita/ausencias/editar-ausencias/editar-ausencias.component').then(
            (c) => c.EditarAusenciasComponent,
          ),
        canActivate: [AuthGuard],
        data: {
          roles: [UserRole.ADMIN],
        },
      },
    ],
  },
  { path: '**', redirectTo: 'home' },
];
